import {ConfigApi, PlaceApi} from "../../../../../../../services/Api/types";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import {usePlaceContext} from "../../../../../../../services/Place/PlaceContext";
import NavbarMulti from "../../../../../../../components/Navbar/NavbarMulti";
import AppConfig from "../../../../../../../services/AppConfig";
import FetchPlaces from "../../../../../../../components/Fetch/FetchPlaces";
import ChangeLocationButtonComponent from "./ChangeLocationButtonComponent";
import MultistorePlaceFilterCitiesComponent from "./MultistorePlaceFilterCitiesComponent";
import PlaceItemMultistoreComponent from "./PlaceItemMultistoreComponent";
import UserUtils from "../../../../../../../services/User/UserUtils";
import AdvertUserComponent from "../../../../../../../components/User/components/AdvertUser";
import Footer from "../../../../../../../components/layout/Footer/Footer";
import {getLanguagesBasedOnStoreType} from "../../../../../../../services/languageUtils";
import {RootState} from "../../../../../../../../reducers";
import {getUser} from "../../../../../../../services/User/reducer";
import {getStoreConfigLoyalty} from "../../../../../../../services/Store/reducer";
import {getSession} from "../../../../../../../services/Session/reducer";
import {connect} from "react-redux";
import {ReactComponent as MapSVG} from "../../../../../../../../images/icons/map.svg";
import {ReactComponent as ListSVG} from "../../../../../../../../images/icons/list.svg";
import Hero from "../../../../../components/Old/Hero";


interface OwnProps {
    config: ConfigApi;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreWithMapHomePageOld = (props: Props) => {
    const [filterCity, setFilterCity] = useState<string | undefined>();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {places} = usePlaceContext();
    const [filteredPlaces, setFilteredPlaces] = useState<PlaceApi[]>(places ?? []);

    useEffect(() => {
        if (filterCity) {
            setFilteredPlaces(((places ?? []).filter(place => place.address?.city == filterCity)));
        } else {
            setFilteredPlaces(places ?? []);
        }
    }, [filterCity, places]);

    const onSuccessLocation = () => {
        navigate("/map")
    }

    return (
        <>
            <NavbarMulti config={props.config}/>
            {!AppConfig.isWidget() && (
                <div className="mb-4">
                    <Hero config={props.config} skipPlaceDetails/>
                </div>
            )}
            <div className={"multistore-places"}>
                <div className={"container-fluid"}>
                    <FetchPlaces>
                        <ChangeLocationButtonComponent config={props.config} onSuccess={onSuccessLocation}/>
                        <div className={"multistore-places-content"}>
                            <MultistorePlaceFilterCitiesComponent places={places} city={filterCity}
                                                                  onChange={(value: string) => setFilterCity(value)}/>
                            {filteredPlaces ? (
                                <>
                                    {filteredPlaces.slice(0, 20).map(place => {
                                        return (
                                            <React.Fragment key={place.domain}>
                                                <PlaceItemMultistoreComponent key={place.domain}
                                                                              place={place}/>
                                            </React.Fragment>
                                        )
                                    })}
                                </>
                            ) : (
                                <>
                                    {t("modules.multistore.field.no_restaurants.title")}
                                </>
                            )}
                        </div>
                        <div className={"multistore-places-buttons"}>
                            <Link to={"list"} className={"btn btn-default btn-flex w-100 btn-lg"}>
                                <>
                                    {t("modules.multistore.action.show_all.title")} <ListSVG/>
                                </>
                            </Link>
                            <Link to={"map"} className={"btn btn-default btn-lg"}
                                  aria-label={t("modules.multistore.field.map.title")}>
                                <MapSVG aria-hidden="true"/>
                            </Link>
                        </div>
                    </FetchPlaces>
                </div>
            </div>
            {(UserUtils.isLoyaltyRegistration(props.config_loyalty) && (!props.user || !props.user.name)) && (
                <AdvertUserComponent/>
            )}
            <Footer config={props.config} languages={getLanguagesBasedOnStoreType(props.config)}
                    withoutMap/>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user),
    config_loyalty: getStoreConfigLoyalty(state.config),
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);

export default connector(MultistoreWithMapHomePageOld);